import React from "react";
import Lunr from "lunr";
import reactStringReplace from "react-string-replace";
import { sidebarOnClicks, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import queryString from 'query-string'
import SDKSidebar from "js/utilities/sdk-sidebar";
import SearchIndex from "js/search-index.json";
import Spinner from "html-components/SpinnerBig";



export default React.createClass({

  mixins: [Navigation],

  displayName: "search",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var value = ''

    // get search data value from url
    if(this.props && this.props.location && this.props.location.search) {
      value = queryString.parse(this.props.location.search).key;
    }

    return {
      siteContent: [],
      index: null,
      value: value,
      lines: [],
      results: [],
      loading: false
    };
  },

  componentDidMount: function() {
    sidebarOnClicks()
  },

  componentWillMount() {
    this.getSearchData(this.state.value)
  },

  render: function() {
    const { results, value } = this.state;
    return (
      <div className="dash support search">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <Glyphicon glyph="search" />
                <h2>Search Docs</h2>
                <hr />
              </div>
            </section>
            <section>
              <div className="app-container">
                <p>Provide keyword(s) to search across FaceTec Docs</p>
                <div className="search-container">
                  <input type="text" value={value} onChange={this.onChange} placeholder="Search..." />
                </div>
                <hr />

                <div className="results-container">
                  {!this.state.loading ? <Results results={results} query={this.state.value} /> : <Spinner className="padding-vert-30 clearfix" />}
                </div>
              </div>
            </section>
            <SDKSidebar menuType="main" title="Search"/>
          </div>
        </div>
      </div>
    )
  },

  onChange(event) {

    // Set captured value to input
    var value = event.target.value

    this.getSearchData(value)

  },

  getSearchData(value) {
    this.setState(() => ({ value: value }));

    if(value.length >= 3) {

      const { siteContent } = this.state;

      // Search against lines and index if they exist
      if(siteContent.lenght > 0) {
        return this.setState(() => ({
          results: this.search(siteContent, value),
        }));
      }

      // If the index doesn't exist, it has to be set it up.
      // You could show loading indicator here as loading might
      // take a while depending on the size of the index.
      var data = []
      this.setState({loading: true})

      for (var i = 0; i < SearchIndex.length; i++) {
        loadIndex(SearchIndex[i], i).then(({ index, lines, url, pageTitle, cnt }) => {
          // Search against the index now.
          data.push({index: index, lines: lines, url: url, pageTitle: pageTitle});
          if(SearchIndex.length == cnt+1) {
            this.setState(() => ({
              siteContent: data,
              results: this.search(data, value),
              loading: false
            }));
          }
        }).catch(err => console.error(err));
      }
    }
    else {
      this.setState(() => ({
        results: [],
        loading: false
      }));
    }
  },

  search(siteContent, query) {
    // Search against index and match all files' line.
    var results = []
    for (var i = 0; i < siteContent.length; i++) {
      var resultsData = []

      resultsData["url"] = siteContent[i].url
      resultsData["pageTitle"] = siteContent[i].pageTitle
      resultsData["content"] = siteContent[i].index
      .search("*" + query.trim() + "*")
      .map(
        match => siteContent[i].lines[match.ref],
      );

      if(resultsData["content"].length > 0) {
        results.push(resultsData)
      }
    }

    return results;
  }
});


const Results = ({results, query}) => {
  if(results && results.length > 0) {

    return (<ul>{
      results.map((result, i) =>
        result.content.map((content, key) => {

          // exclude code inside render content
          if(content.indexOf("}") != -1 || content.indexOf("))") != -1 ) {
            return false;
          }

          // Show only 1 record per page
          if(key < 1) {
            // Highlight search keyword in content
            let textHighlighter = highlightMatchesInString(content, query)

            return <Link to={result.url}>
              <li key={i+key}>
                <div>
                  <h4>{result.pageTitle}</h4>
                  <p>{textHighlighter}</p>
                </div>
              </li></Link>;
          }
        }
      ))
    }</ul>);
  }
  else if(query.length >= 3) {
    return <span>Your search for '{query}' returned 0 results</span>;
  }
  else {
    return <span></span>;
  }
};

function highlightMatchesInString(content, query) {
  query = query.split(" ");
  query.forEach(function(item, key) {
    if(item.length >= 3) {
      content = reactStringReplace(content, item, (match, i) => (
        <span key={match + i + Math.random()} className="highlighted">{match}</span>
      ));
    }
  });
  return content;
}

function loadIndex(SearchIndex, cnt) {
  // Here's the magic. Set up `import` to tell Webpack
  // to split here and load our search index dynamically.
  //
  // Note that you will need to shim Promise.all for
  // older browsers and Internet Explorer!

  return Promise.all([
    Lunr,
    SearchIndex["data"]
  ]).then(([{ Index }, { index, lines }]) => {
    return {
      index: Index.load(index),
      lines,
      url: SearchIndex["url"],
      pageTitle: SearchIndex["pageTitle"],
      cnt: cnt
    };
  });
}



// WEBPACK FOOTER //
// ./src/js/components/screens/search.jsx